import React, { useState, useEffect, useMemo } from 'react';
import SearchDropdown from '../../atoms/searchdropdown/view';
import { getMunicipalities } from '../../../usecases/thirds-usecase';
import './style.css';

const MunicipalitySearchDropdown = ({ selected, onSelected }) => {
    const [municipalities, setMunicipalities] = useState([]);
    const [showSearch, setShowSearch] = useState(!selected);

    useEffect(() => {
        getMunicipalities('').then(setMunicipalities).catch(() => setMunicipalities([]));
    }, []);

    useEffect(() => {
        setShowSearch(!selected);
    }, [selected]);

    const options = useMemo(() =>
        municipalities.map((m) => ({
            key: m.id,
            name: m.name,
            code: m.code,
        })),
        [municipalities]
    );

    const selectedLabel = selected?.name || null;

    const handleSelect = (option) => {
        if (onSelected) onSelected({ id: option.key, name: option.name, code: option.code });
        setShowSearch(false);
    };

    const handleRemove = () => {
        if (onSelected) onSelected(null);
        setShowSearch(true);
    };

    if (!showSearch && selectedLabel) {
        return (
            <div className="muni-chip-wrapper">
                <span className="muni-chip">
                    <span className="muni-chip-label">{selectedLabel}</span>
                    <button
                        type="button"
                        className="muni-chip-remove"
                        onClick={handleRemove}
                        aria-label="Quitar municipio"
                        title="Quitar municipio"
                    >
                        ×
                    </button>
                </span>
            </div>
        );
    }

    return (
        <SearchDropdown
            placeholder="Buscar municipio..."
            options={options}
            path="name"
            onSelect={handleSelect}
        />
    );
};

export default MunicipalitySearchDropdown;
